import TimeLib from '../../../../lib/Time'
import {
  ICurrency,
  IEventPaymentSettingsInterface,
} from '../../../../models/event-payment-settings/event-payment-settings.interface'

export const DATA_FIRESTORE_V01_EVENT_PAYMENT_SETTINGS = {
  NAME: 'v01_event_payments_settings',
  FIELDS: {
    VERSION: {
      KEY: 'v',
      VALUES: {
        DEFAULT: 1,
      },
    },

    ID: {
      KEY: 'id',
      VALUES: {
        DEFAULT: null,
      },
    },

    ALLOW_WITHOUT_PAYMENT: {
      KEY: 'allowWithoutPayment',
      VALUES: {
        DEFAULT: false,
        YES: true,
        NO: false,
      },
    },

    ALLOW_CREDIT_CARD_PAYMENT: {
      KEY: 'allowCreditCardPayment',
      VALUES: {
        DEFAULT: false,
        YES: true,
        NO: false,
      },
    },

    ALLOW_ACH_PAYMENT: {
      KEY: 'allowACHPayment',
      VALUES: {
        DEFAULT: false,
        YES: true,
        NO: false,
      },
    },

    ALLOW_SPLIT_PAYMENT: {
      KEY: 'allowSplitPayment',
      VALUES: {
        DEFAULT: false,
        YES: true,
        NO: false,
      },
    },

    ALLOW_DELAYED_PAYMENT: {
      KEY: 'allowDelayedPayment',
      VALUES: {
        DEFAULT: false,
        YES: true,
        NO: false,
      },
    },

    CHARGE_SALES_TAX: {
      KEY: 'chargeSalesTax',
      VALUES: {
        DEFAULT: false,
        YES: true,
        NO: false,
      },
    },

    CURRENCY: {
      KEY: 'currency',
      VALUES: {
        DEFAULT: 'USD' as ICurrency,
      },
    },

    PAYMENT_OPTION: {
      KEY: 'paymentOption',
      VALUES: {
        DEFAULT: 'LeavePricesAsIs' as IEventPaymentSettingsInterface['paymentOption'],
        /** @info `LeavePricesAsIs` - Leave prices as they are. Organizer will pay 5% fee. */
        LEAVE_PRICE_AS_IS: 'LeavePricesAsIs' as IEventPaymentSettingsInterface['paymentOption'],
        /** @info `IncreaseAllPrices` - Increase all prices by 5% to cover Pegasus’ fee.  */
        INCREASE_ALL_PRICES: 'IncreaseAllPrices' as IEventPaymentSettingsInterface['paymentOption'],
        /** @info `ChargeRidersAndSpectators` - Charge riders & spectators 2.5% + 30c credit card processing fee. Organizer pays remaining 2.5%. */
        CHARGE_RIDERS_AND_SPECTORORS:
          'ChargeRidersAndSpectators' as IEventPaymentSettingsInterface['paymentOption'],
      },
    },

    CREATED: {
      KEY: 'created',
      VALUES: {
        NULL: null,
        DEFAULT: TimeLib.utcTimestamp(),
      },
    },

    MODIFIED: {
      KEY: 'modified',
      VALUES: {
        NULL: null,
        DEFAULT: TimeLib.utcTimestamp(),
      },
    },
  },
}
